// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d0c3e8f4","455":"4a01a27b","644":"8d2afb8b"}[chunkId] + ".chunk.js";
};